<template>
  <div class="body-box  marginBox">
    <!-- 搜索与添加区域 -->
    <el-row class="plan">
      <el-col :span="24" style='margin-top: 15px'>
        <el-tabs v-model="activeName" @tab-click="btnStatus">
          <el-tab-pane label="全部" name="ALL"></el-tab-pane>
          <el-tab-pane label="普通文章" name="ORDINARY"></el-tab-pane>
          <el-tab-pane label="相关推荐" name="RELEVANT"></el-tab-pane>
          <el-tab-pane label="VIP" name="VIP"></el-tab-pane>
          <el-tab-pane label="比赛文章" name="RACE_NEWS"></el-tab-pane>
        </el-tabs>
      </el-col>

      <el-col :span="19">
        <el-button icon="el-icon-plus" @click="addArticle">新增</el-button>
      </el-col>

      <el-col :span="5">
        <search-input v-model="queryInfo.keyword" placeholder="请输入关键字进行搜索" @change="handleQuery"/>
      </el-col>
    </el-row>

    <!--列表-->
    <el-table :height="'calc(100% - 140px)'" :data="articleList" class="button-box">
      <el-table-column label="标题" prop="title"></el-table-column>
      <el-table-column label="缩略图" prop="thumbnail">
        <template slot-scope="scope">
          <icon-img :icon="scope.row.thumbnail"></icon-img>
        </template>
      </el-table-column>
      <el-table-column label="文章类型" prop="content">
        <template slot-scope="scope">
          {{scope.row.enumAttribute | enumAttributeStatus}}
        </template>
      </el-table-column>
      <el-table-column label="是否启用" prop="enumEnable">
        <template slot-scope="scope">
          {{scope.row.enumEnable === 'NORMAL' ? '是' : '否'}}
        </template>
      </el-table-column>
      <el-table-column label="排序" prop="sort"></el-table-column>
      <el-table-column label="列表页置顶" prop="top"  sortable>
        <template slot-scope="scope">
          {{ scope.row.top | topStatus }}
        </template>
      </el-table-column>
      <el-table-column label="创建时间" prop="createDatetime"  sortable>
        <template slot-scope="scope">
          {{ scope.row.createDatetime | formatDate }}
        </template>
      </el-table-column>
      <el-table-column label="发布时间" prop="releaseTime"  sortable>
        <template slot-scope="scope">
          {{ scope.row.releaseTime | formatDate }}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="180px">
        <template slot-scope="scope">
          <el-button icon="el-icon-edit" @click="editArticle(scope.row)">修改</el-button>
          <el-button icon="el-icon-delete" @click="removeArticleById(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页区域 -->
    <div class="fixedBox"><pagination ref="page" :query-param.sync="queryInfo" @pagination="getArticleList" /></div>


    <addArticle @refresh-list="handleQuery" ref="addArticle"></addArticle>
    <editArticle @refresh-list="handleQuery" ref="editArticle"></editArticle>
  </div>
</template>
<script>
import Pagination from '@/components/common/Pagination/index'
import addArticle from '@/views/article/addArticle'
import editArticle from '@/views/article/editArticle'
import { getPostOrDeleteData } from '@/utils/code'
import { deleteArticle, articleList } from '@/api/article/article'
import SearchInput from '@/components/common/searchInput/searchInput'
import IconImg from '@/components/common/pictureImg/index'

export default {
  components: { IconImg, SearchInput, Pagination, addArticle, editArticle },
  data() {
    return {
      queryInfo: {
        keyword: '',
        enumAttribute: ''
      },
      articleList: [],
      activeName: 'ALL'
    }
  },
  created() {
    this.handleQuery()
  },

  watch: {
    queryInfo(newData) {
      this.activeName = newData.enumAttribute === '' ? 'ALL' : newData.enumAttribute
    }
  },

  methods: {
    //查询列表
    getArticleList(page, cb) {
      articleList(page).then((response) => {
        this.articleList = cb(response)
      })
    },

    btnStatus(val) {
      this.queryInfo.enumAttribute = val.name ===  'ALL' ? '' : val.name
      this.handleQuery()
    },

    //根据ID删除数据
    removeArticleById(id) {
      this.$confirm('确定要删除吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteArticle(id).then((response) => {
          let data = getPostOrDeleteData(response)
          if (data !== null) {
            this.handleQuery()
          }
        })
      }).catch(() => {
      })
    },

    //新增
    addArticle() {
      this.$refs.addArticle.addDialog()
    },

    //修改
    editArticle(row) {
      this.$refs.editArticle.editDialog(row)
    },

    //查询按钮
    handleQuery() {
      this.$nextTick(() => {
        this.$refs.page.run()
      })
    },

  }
}
</script>

<style lang="less" scoped>
/deep/ .el-dialog {
  padding-right: 30px;
}
</style>
